import { Link } from 'react-router-dom';
import office from '../office.jpg';
import Icon from '../Components/Icon';
import ContactBand from '../Components/ContactBand';
import { partners, products, stats } from '../data/site';

const Home = () => (
  <>
    <section className="hero">
      <svg className="hero__swoosh" viewBox="0 0 800 800" aria-hidden="true">
        <ellipse cx="400" cy="400" rx="380" ry="230" transform="rotate(-28 400 400)" />
        <ellipse cx="400" cy="400" rx="300" ry="170" transform="rotate(-28 400 400)" />
      </svg>
      <div className="container hero__grid">
        <div>
          <p className="eyebrow eyebrow--light">Healthcare products, sales and service</p>
          <h1>Connecting hospitals with the manufacturers they rely on</h1>
          <p className="hero__lead">
            We bridge the gap between hospitals, pathology centres and manufacturers
            across Northern India.
          </p>
          <div className="button-row">
            <Link to="/contact" className="button button--light">Contact us</Link>
            <Link to="/clients" className="button button--ghost">View our clients</Link>
          </div>
        </div>
        <img className="hero__image" src={office} alt="Colleagues reviewing a presentation in a meeting room" />
      </div>
    </section>

    <section className="stats" aria-label="Company at a glance">
      <div className="container stats__grid">
        {stats.map((stat) => (
          <div key={stat.label} className="stat">
            <div className="stat__value">{stat.value}</div>
            <div className="stat__label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">What we supply</p>
          <h2>Products and services for private and government hospitals</h2>
        </div>
        <div className="card-grid card-grid--four">
          {products.map((product) => (
            <article key={product.title} className="card">
              <span className="card__icon"><Icon name={product.icon} /></span>
              <h3>{product.title}</h3>
              <p>{product.desc}</p>
            </article>
          ))}
        </div>
        <Link to="/readMore" className="text-link">
          More about the company <Icon name="arrow" size={18} />
        </Link>
      </div>
    </section>

    <section className="section section--tint">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">Our partners</p>
          <h2>Trusted by leading manufacturers</h2>
        </div>
        <div className="partner-grid">
          {partners.map((partner) => (
            <a key={partner.name} className="partner" href={partner.link} target="_blank" rel="noreferrer">
              <img src={partner.img} alt={partner.name} />
            </a>
          ))}
        </div>
      </div>
    </section>

    <ContactBand />
  </>
);

export default Home;
